export default {
  h1_edu: "دوره‌های آموزشی برای پزشکان تشخیص‌ دهنده",
  Lessons: {
    Lesson: {
      title: "درس",
      Files: "پیوست‌ها",
      DownloadAll: "دانلود همه",
    },
    status: {
      success: "موفق",
      unsuccess: "ناموفق",
      stop: "غیرفعال",
    },
  },
};
